// Lightweight, fire-and-forget analytics client.
// Failures must never affect the user experience.
import axios from "axios";
import logger from "./logger";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TRACK_ENDPOINT = `${BACKEND_URL}/api/track`;

const trackerClient = axios.create({
  baseURL: BACKEND_URL,
  timeout: 4000,
  headers: { "Content-Type": "application/json" },
});

const send = (payload) => {
  // Never await this; analytics must never slow the UI or surface errors.
  trackerClient.post("/api/track", payload).catch(() => {});
};

export const trackPageview = (path) => {
  send({ type: "pageview", path: path || window.location.pathname });
};

export const trackEvent = (type, path = "", meta = null) => {
  send({ type, path, meta });
};

// Sometimes navigations happen mid-click (target=_blank). sendBeacon survives
// page unloads better than fetch.
export const trackEventBeacon = (type, path = "", meta = null) => {
  if (typeof navigator !== "undefined" && navigator.sendBeacon) {
    try {
      const blob = new Blob(
        [JSON.stringify({ type, path, meta })],
        { type: "application/json" },
      );
      navigator.sendBeacon(TRACK_ENDPOINT, blob);
      return;
    } catch (err) {
      // sendBeacon failure (CSP, quota, etc.) — fall back to axios below
      logger.warn("sendBeacon failed, falling back to axios:", err.message);
    }
  }
  send({ type, path, meta });
};
